<div class="row text-left justify-content-md-center mt-5">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title" id="basic-layout-form">{{ 'account.twoFactorLogin.title' | translate }}</h4>
        <p class="mb-0">{{ 'account.twoFactorLogin.text' | translate }}</p>
      </div>
      <div class="card-body">
        <div class="px-3">
          <form class="form" #twoFactorAuthenticationloginForm="ngForm"
                (ngSubmit)="onSubmit(twoFactorAuthenticationloginForm)">
            <div class="form-body">
              <h4 class="form-section">
                <i class="ft-cpu"></i> {{ 'account.twoFactorLogin.detailsHeader' | translate }}
              </h4>

              <!-- Two Factor Authentication Code -->
              <div class="form-group">
                <label
                  for="AuthenticationCode">{{ 'account.twoFactorLogin.authenticationCodeFieldLabel' | translate }}</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="icon-key"></i>
                    </span>
                  </div>
                  <input type="text" class="form-control" name="AuthenticationCode" #AuthenticationCode="ngModel"
                         placeholder="{{'account.twoFactorLogin.authenticationCodeFieldPlaceHolder' | translate}}"
                         [(ngModel)]="authenticationCode" required>
                </div>
              </div>
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary btn-raised mr-1"
                      [disabled]="!twoFactorAuthenticationloginForm.valid">
                <i class="ft-log-in"></i> {{ 'buttons.loginText' | translate }}
              </button>
              <button type="button" class="btn btn-outline-primary mr-1" [routerLink]="['/account/login']">
                <i class="ft-arrow-left"></i> {{ 'buttons.backText' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
